import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const ProfilePageContent = styled.div`
  max-width: 1000px;

  .routed-tab .ui.tabular.menu {
    padding: 0;
    background: none;
    border: none;
    margin-bottom: 24px;
    border-bottom: 1px solid ${globals.MOON_350};
    overflow: visible;
    .item {
      border: none;
    }
    .item.active {
      border: 1px solid ${globals.MOON_350};
      border-bottom: none;
      background: ${globals.MOON_100};
      margin-bottom: -1px;
      padding-bottom: 12px;
    }
  }
`;
ProfilePageContent.displayName = 'S.ProfilePageContent';
